import { render, staticRenderFns } from "./documents.revenuedepartment.pnd1to3.vue?vue&type=template&id=4910c108&scoped=true"
import script from "./documents.revenuedepartment.pnd1to3.vue?vue&type=script&lang=js"
export * from "./documents.revenuedepartment.pnd1to3.vue?vue&type=script&lang=js"
import style0 from "./documents.revenuedepartment.pnd1to3.vue?vue&type=style&index=0&id=4910c108&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4910c108",
  null
  
)

export default component.exports